// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles.js';
import styles from '../styles/HorizontalCarouselCNC.style';

const CouponList = (props) => {
  const { data, childrenComp } = props;

  return (
    <div className="coupon-list">
      {data?.map((coupon) => (
        <div key={coupon.id} className="coupon-item">
          {childrenComp(props, coupon)}
        </div>
      ))}
    </div>
  );
};

CouponList.propTypes = {
  data: PropTypes.arrayOf({}).isRequired,
  childrenComp: PropTypes.func.isRequired,
};

export default withStyles(CouponList, styles);
